import React, {useEffect, useState} from 'react';
import {get, post} from '../../core/http';
import {API} from '../../core/constants';
import Modal from '../ui/Modal';

const ImportArticleDialog = ({defaultEventId, onImported, onCancel}) => {
    const [url, setUrl] = useState('');
    const [eventId, setEventId] = useState(defaultEventId || '');
    const [eventOptions, setEventOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const getEventOptions = async () => {
            const result = await get(`${API}/event-options`);

            if (result.body) {
                setEventOptions(result.body);
            }
        };

        getEventOptions();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!url) {
            setError('URL is required');
            return;
        }

        setLoading(true);

        try {
            const result = await post(`${API}/articles/from-url`).send({
                url,
                eventId: eventId || undefined,
            });

            onImported(result.body);
        } catch (err) {
            setError(err?.response?.body?.message || 'Could not extract or summarize that URL.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Import article from URL"
            description={`We'll extract the article text, summarize it, and save it as a draft for review${defaultEventId ? '' : ' (and try to match it to an existing event)'}.`}
            onClose={onCancel}
        >
            <form onSubmit={handleSubmit} className="space-y-3">
                <label className="block">
                    <span className="label-text text-xs font-semibold">Article URL</span>
                    <input
                        className="input input-bordered input-sm w-full mt-1"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="https://example.com/news/story"
                        disabled={loading}
                    />
                </label>

                <label className="block">
                    <span className="label-text text-xs font-semibold">
                        Event {defaultEventId ? '' : '(optional — leave blank to let AI try to match, or assign later)'}
                    </span>
                    <select
                        className="select select-bordered select-sm w-full mt-1"
                        value={eventId}
                        onChange={(e) => setEventId(e.target.value)}
                        disabled={loading}
                    >
                        <option value="">Select...</option>
                        {eventOptions.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.title}
                            </option>
                        ))}
                    </select>
                </label>

                {error && <p className="text-error text-xs">{error}</p>}

                <div className="flex gap-2 pt-2">
                    <button type="button" className="btn btn-ghost btn-sm flex-1" onClick={() => onCancel()} disabled={loading}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-sm flex-1" type="submit" disabled={loading}>
                        {loading ? 'Extracting & summarizing…' : 'Import'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default ImportArticleDialog;
